<a [FCRouterLink]="seoService.getAdvertiserDisclosurePage()" id="fc-advertiser-disclosure" [target]="target">
    {{message}}<i class="fas fa-info-circle" [tooltip]="'Why is this advertised?'"></i>
</a>